import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSzakKomm, createSzakKomm, updateSzakKomm, getSzak } from "../../apis/SzakokFinder";
// import "../../components/Ujszak.css";
import "./RadioButton.css";
import SideTile from "../SideTile";
// import "./SzakKomm.css";
import "./SzakjelentesCreate.css";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext";
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import TopAlert from '../../components/TopAlert';
import {
    FELVETELI_INFO_LINK_OPTIONS,
    INFORMACIO_MINOSEG_OPTIONS,
    KOZOSSEGI_MEDIA_PLATFORMOK_OPTIONS,
    KOZOSSEGI_MEDIA_STRATEGIA_OPTIONS,
    KOMMUNIKACIO_IGAZGATOSAG_EGYEZTETES_OPTIONS,
    SZOLGALTATASI_IGAZGATOSAG_EGYEZTETES_OPTIONS,
    KOMMUNIKACIOS_AKTIVITAS_OPTIONS
} from './SzakKommOptions';
import { SZAK_KOMM_TRANSLATIONS } from './SzakKommTranslations';


const SzakKommContent = ({ szakKod }) => {
    console.log('SzakKommContent rendering with szakKod:', szakKod);

    const [isSideTileVisible] = useState(true);
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();
    const { language, loading } = useLanguage();

    console.log('SzakKommContent language state:', { language, loading });

    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);

    const [szakKommData, setSzakKommData] = useState({
        filling_status: 1
    });

    // State for each field
    const [felvetelInfoLink, setFelvetelInfoLink] = useState([]);
    const [felvetelInfoLinkEgyeb, setFelvetelInfoLinkEgyeb] = useState("");
    const [informacioMinoseg, setInformacioMinoseg] = useState("");
    const [kozossegiMediaPlatformok, setKozossegiMediaPlatformok] = useState([]);
    const [kozossegiMediaPlatformokEgyeb, setKozossegiMediaPlatformokEgyeb] = useState("");
    const [kozossegiMediaStrategia, setKozossegiMediaStrategia] = useState("");
    const [kommunikacioIgazgatosagEgyeztetes, setKommunikacioIgazgatosagEgyeztetes] = useState("");
    const [szolgaltatIgazgatosagEgyeztetes, setSzolgaltatIgazgatosagEgyeztetes] = useState("");
    const [kommunikaciosAktivitas, setKommunikaciosAktivitas] = useState("");

    const [isNew, setIsNew] = useState(true);
    const [szakStatus, setSzakStatus] = useState(1); // Mely státuszban van a szakjelentés

    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    // Get translations and options for current language
    const t = loading ? {} : (SZAK_KOMM_TRANSLATIONS[language] || SZAK_KOMM_TRANSLATIONS.hu);
    console.log('SzakKommContent translations:', { loading, language, hasSidebar: !!t.sidebar, t });

    const felvetelInfoLinkOptions = loading ? [] : (FELVETELI_INFO_LINK_OPTIONS[language] || FELVETELI_INFO_LINK_OPTIONS.hu);
    const informacioMinosegOptions = loading ? [] : (INFORMACIO_MINOSEG_OPTIONS[language] || INFORMACIO_MINOSEG_OPTIONS.hu);
    const kozossegiMediaPlatformokOptions = loading ? [] : (KOZOSSEGI_MEDIA_PLATFORMOK_OPTIONS[language] || KOZOSSEGI_MEDIA_PLATFORMOK_OPTIONS.hu);
    const kozossegiMediaStrategiaOptions = loading ? [] : (KOZOSSEGI_MEDIA_STRATEGIA_OPTIONS[language] || KOZOSSEGI_MEDIA_STRATEGIA_OPTIONS.hu);
    const kommunikacioIgazgatosagOptions = loading ? [] : (KOMMUNIKACIO_IGAZGATOSAG_EGYEZTETES_OPTIONS[language] || KOMMUNIKACIO_IGAZGATOSAG_EGYEZTETES_OPTIONS.hu);
    const szolgaltatIgazgatosagOptions = loading ? [] : (SZOLGALTATASI_IGAZGATOSAG_EGYEZTETES_OPTIONS[language] || SZOLGALTATASI_IGAZGATOSAG_EGYEZTETES_OPTIONS.hu);
    const kommunikaciosAktivitasOptions = loading ? [] : (KOMMUNIKACIOS_AKTIVITAS_OPTIONS[language] || KOMMUNIKACIOS_AKTIVITAS_OPTIONS.hu);

    // Helper function to build JSONB structure
    const buildRadioData = (selectedValue, options) => {
        if (!selectedValue) return null;
        return {
            selected: selectedValue,
            options: options
        };
    };

    // Helper function to build checkbox data
    const buildCheckboxData = (selectedValues, options) => {
        if (!selectedValues || selectedValues.length === 0) return null;
        return {
            selected: selectedValues,
            options: options
        };
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Lekérjük a szak adatait a státusz beállításához
                const szakResponse = await getSzak(szakId);
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }

                const response = await getSzakKomm(szakId);
                if (response.data && response.data.data) {
                    const data = response.data.data;
                    setSzakKommData(data);
                    
                    // Load data from JSONB
                    if (data.felvetel_info_link) setFelvetelInfoLink(data.felvetel_info_link.selected || []);
                    if (data.felvetel_info_link_egyeb) setFelvetelInfoLinkEgyeb(data.felvetel_info_link_egyeb);
                    if (data.informacio_minoseg) setInformacioMinoseg(data.informacio_minoseg.selected || "");
                    if (data.kozossegi_media_platformok) setKozossegiMediaPlatformok(data.kozossegi_media_platformok.selected || []);
                    if (data.kozossegi_media_platformok_egyeb) setKozossegiMediaPlatformokEgyeb(data.kozossegi_media_platformok_egyeb);
                    if (data.kozossegi_media_strategia) setKozossegiMediaStrategia(data.kozossegi_media_strategia.selected || "");
                    if (data.kommunikacio_igazgatosag_egyeztetes) setKommunikacioIgazgatosagEgyeztetes(data.kommunikacio_igazgatosag_egyeztetes.selected || "");
                    if (data.szolgaltat_igazgatosag_egyeztetes) setSzolgaltatIgazgatosagEgyeztetes(data.szolgaltat_igazgatosag_egyeztetes.selected || "");
                    if (data.kommunikacios_aktivitas) setKommunikaciosAktivitas(data.kommunikacios_aktivitas.selected || "");
                    
                    setIsNew(false);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                // Handle case when no record exists (404)
                if (error.response && error.response.status === 404) {
                    const newData = {
                        filling_status: 1,
                    };
                    try {
                        await createSzakKomm(szakId, newData);
                        setSzakKommData(newData);
                        window.location.reload();
                    } catch (createError) {
                        console.error("Error creating initial record:", createError);
                    }
                }
            }
        };
        fetchData();
    }, [szakId]);

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = { 
                ...szakKommData, 
                filling_status: 2,
                felvetel_info_link: buildCheckboxData(felvetelInfoLink, felvetelInfoLinkOptions),
                felvetel_info_link_egyeb: felvetelInfoLinkEgyeb,
                informacio_minoseg: buildRadioData(informacioMinoseg, informacioMinosegOptions),
                kozossegi_media_platformok: buildCheckboxData(kozossegiMediaPlatformok, kozossegiMediaPlatformokOptions),
                kozossegi_media_platformok_egyeb: kozossegiMediaPlatformokEgyeb,
                kozossegi_media_strategia: buildRadioData(kozossegiMediaStrategia, kozossegiMediaStrategiaOptions),
                kommunikacio_igazgatosag_egyeztetes: buildRadioData(kommunikacioIgazgatosagEgyeztetes, kommunikacioIgazgatosagOptions),
                szolgaltat_igazgatosag_egyeztetes: buildRadioData(szolgaltatIgazgatosagEgyeztetes, szolgaltatIgazgatosagOptions),
                kommunikacios_aktivitas: buildRadioData(kommunikaciosAktivitas, kommunikaciosAktivitasOptions)
            };
            try {
                if (isNew) {
                    await createSzakKomm(szakId, updatedData);
                } else {
                    await updateSzakKomm(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [felvetelInfoLink, felvetelInfoLinkEgyeb, informacioMinoseg, 
        kozossegiMediaPlatformok, kozossegiMediaPlatformokEgyeb, kozossegiMediaStrategia,
        kommunikacioIgazgatosagEgyeztetes, szolgaltatIgazgatosagEgyeztetes, kommunikaciosAktivitas,
        szakKommData, isNew, szakId, registerSaveHandler, unregisterSaveHandler]);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        try {
            const updatedData = { 
                ...szakKommData, 
                filling_status: status,
                felvetel_info_link: buildCheckboxData(felvetelInfoLink, felvetelInfoLinkOptions),
                felvetel_info_link_egyeb: felvetelInfoLinkEgyeb,
                informacio_minoseg: buildRadioData(informacioMinoseg, informacioMinosegOptions),
                kozossegi_media_platformok: buildCheckboxData(kozossegiMediaPlatformok, kozossegiMediaPlatformokOptions),
                kozossegi_media_platformok_egyeb: kozossegiMediaPlatformokEgyeb,
                kozossegi_media_strategia: buildRadioData(kozossegiMediaStrategia, kozossegiMediaStrategiaOptions),
                kommunikacio_igazgatosag_egyeztetes: buildRadioData(kommunikacioIgazgatosagEgyeztetes, kommunikacioIgazgatosagOptions),
                szolgaltat_igazgatosag_egyeztetes: buildRadioData(szolgaltatIgazgatosagEgyeztetes, szolgaltatIgazgatosagOptions),
                kommunikacios_aktivitas: buildRadioData(kommunikaciosAktivitas, kommunikaciosAktivitasOptions)
            };
            if (isNew) {
                await createSzakKomm(szakId, updatedData);
            } else {
                await updateSzakKomm(szakId, updatedData);
            }
            navigate(0);
        } catch (error) {
            console.error("Hiba az adatok mentésekor:", error);
            alert("Hiba történt az adatok mentésekor.");
        }
    };

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/megvalositas-ertekelese`); 
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/tanulmanyi-korulmenyek`);
    };

    const isFormValid = () => {
        const hasContent = (html) => {
            if (!html) return false;
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        let valid = felvetelInfoLink.length > 0 &&
                    informacioMinoseg &&
                    kozossegiMediaPlatformok.length > 0 &&
                    kozossegiMediaStrategia &&
                    kommunikacioIgazgatosagEgyeztetes &&
                    szolgaltatIgazgatosagEgyeztetes &&
                    kommunikaciosAktivitas;

        // If "egyeb" is selected in felvetelInfoLink, the text field is mandatory
        if (felvetelInfoLink.includes('egyeb') && !hasContent(felvetelInfoLinkEgyeb)) {
            valid = false;
        }

        // If "egyeb" is selected in kozossegiMediaPlatformok, the text field is mandatory
        if (kozossegiMediaPlatformok.includes('egyeb') && !hasContent(kozossegiMediaPlatformokEgyeb)) {
            valid = false;
        }

        return valid;
    };

    const handleFinalize = async (e) => {
        if (szakKommData.filling_status === 3) {
            // Visszavonás - használjuk a handleSubmit-ot a konzisztencia érdekében
            handleSubmit(e, 2);
        } else {
            if (isFormValid()) {
                handleSubmit(e, 3); // Véglegesítés
            } else {
                // Show top alert instead of native alert
                setAlertMessage(t.alerts.requiredFields);
                setShowAlert(true);
            }
        }
    };

    // Show loading state while language context is initializing
    if (loading) {
        return <div>Loading language...</div>;
    }

    if (!t || !t.sidebar) {
        console.error('SzakKomm: Missing translations or sidebar', { t, language, loading });
        return <div>Error: Missing translations</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <SideTile ref={sideTileRef} id={szakId} texts={t.sidebar}
            isVisible={isSideTileVisible}
            />
            <div className="uj-szak-container">
                <h1 className="esg-title">{t.esgTitle}</h1>
                <h1>{t.pageTitle}</h1>
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    <div className="card">
                        <h2>{t.section1.title}</h2>


                        <h4>{t.section1.felvetelInfo}</h4>
                        <p>{t.section1.link}<a href="https://seafile.sze.hu/f/96d4a99f95c14a639192/" target="_blank" rel="noopener noreferrer">https://seafile.sze.hu/f/96d4a99f95c14a639192/</a></p>
                        <div className="form-group">
                            {felvetelInfoLinkOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`felvetel_info_link_${option.value}`}
                                        name="felvetel_info_link"
                                        value={option.value}
                                        checked={felvetelInfoLink.includes(option.value)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setFelvetelInfoLink([...felvetelInfoLink, e.target.value]);
                                            } else {
                                                setFelvetelInfoLink(felvetelInfoLink.filter(v => v !== e.target.value));
                                            }
                                        }}
                                        disabled={szakKommData.filling_status === 3}
                                    />
                                    <label htmlFor={`felvetel_info_link_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                        {felvetelInfoLink.includes('egyeb') && (
                            <div className="form-group">
                                <RichTextEditor
                                    name="felvetel_info_link_egyeb"
                                    value={felvetelInfoLinkEgyeb}
                                    onChange={setFelvetelInfoLinkEgyeb}
                                    disabled={szakKommData.filling_status === 3}
                                />
                            </div>
                        )}

                        <h4>{t.section1.informacioMinoseg}</h4>
                        <p>{t.section1.hirdetesek}</p>
                        <div className="form-group">
                            {informacioMinosegOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`informacio_minoseg_${option.value}`}
                                        name="informacio_minoseg"
                                        value={option.value}
                                        checked={informacioMinoseg === option.value}
                                        onChange={(e) => setInformacioMinoseg(e.target.value)}
                                        disabled={szakKommData.filling_status === 3}
                                    />
                                    <label htmlFor={`informacio_minoseg_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section1.kozossegiMediaPlatformok}</h4>
                        <div className="form-group">
                            {kozossegiMediaPlatformokOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`kozossegi_media_platformok_${option.value}`}
                                        name="kozossegi_media_platformok"
                                        value={option.value}
                                        checked={kozossegiMediaPlatformok.includes(option.value)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setKozossegiMediaPlatformok([...kozossegiMediaPlatformok, e.target.value]);
                                            } else {
                                                setKozossegiMediaPlatformok(kozossegiMediaPlatformok.filter(v => v !== e.target.value));
                                            }
                                        }}
                                        disabled={szakKommData.filling_status === 3}
                                    />
                                    <label htmlFor={`kozossegi_media_platformok_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                        {kozossegiMediaPlatformok.includes('egyeb') && (
                            <div className="form-group">
                                <RichTextEditor
                                    name="kozossegi_media_platformok_egyeb"
                                    value={kozossegiMediaPlatformokEgyeb}
                                    onChange={setKozossegiMediaPlatformokEgyeb}
                                    disabled={szakKommData.filling_status === 3}
                                />
                            </div>
                        )}

                        <h4>{t.section1.kozossegiMediaStrategia}</h4>
                        <div className="form-group">
                            {kozossegiMediaStrategiaOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`kozossegi_media_strategia_${option.value}`}
                                        name="kozossegi_media_strategia"
                                        value={option.value}
                                        checked={kozossegiMediaStrategia === option.value}
                                        onChange={(e) => setKozossegiMediaStrategia(e.target.value)}
                                        disabled={szakKommData.filling_status === 3}
                                    />
                                    <label htmlFor={`kozossegi_media_strategia_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section2.title}</h2>
                        
                        <h4>{t.section2.kommunikacioIgazgatosag}</h4>
                        <div className="form-group">
                            {kommunikacioIgazgatosagOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`kommunikacio_igazgatosag_${option.value}`}
                                        name="kommunikacio_igazgatosag_egyeztetes"
                                        value={option.value}
                                        checked={kommunikacioIgazgatosagEgyeztetes === option.value}
                                        onChange={(e) => setKommunikacioIgazgatosagEgyeztetes(e.target.value)}
                                        disabled={szakKommData.filling_status === 3}
                                    />
                                    <label htmlFor={`kommunikacio_igazgatosag_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section2.szolgaltatIgazgatosag}</h4>
                        <div className="form-group">
                            {szolgaltatIgazgatosagOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`szolgaltat_igazgatosag_${option.value}`}
                                        name="szolgaltat_igazgatosag_egyeztetes"
                                        value={option.value}
                                        checked={szolgaltatIgazgatosagEgyeztetes === option.value}
                                        onChange={(e) => setSzolgaltatIgazgatosagEgyeztetes(e.target.value)}
                                        disabled={szakKommData.filling_status === 3}
                                    />
                                    <label htmlFor={`szolgaltat_igazgatosag_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                        
                        <div className="card">
                        <h2>{t.section3.title}</h2>
                        <div className="form-group">
                            {kommunikaciosAktivitasOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`kommunikacios_aktivitas_${option.value}`}
                                        name="kommunikacios_aktivitas"
                                        value={option.value}
                                        checked={kommunikaciosAktivitas === option.value}
                                        onChange={(e) => setKommunikaciosAktivitas(e.target.value)}
                                        disabled={szakKommData.filling_status === 3}
                                    />
                                    <label htmlFor={`kommunikacios_aktivitas_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="button-container">
                        <button className="szak-button" type="button" onClick={handleBack}>{t.buttons.previous}</button>
                        <button className="szak-button" type="button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={szakKommData.filling_status === 3 || szakStatus >= 2}>{t.buttons.save}</button>
                        <button className="szak-button finalize-button" type="button" onClick={handleFinalize} disabled={szakStatus >= 2}>
                            {szakKommData.filling_status === 3 ? t.buttons.unfinalize : t.buttons.finalize}
                        </button>
                    </div>
                </form>
            </div>
        </div>
        </div>
    );
};

const SzakKomm = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    console.log('SzakKomm wrapper rendering', { szakId, szakKod, error });

    useEffect(() => {
        const fetchSzakKod = async () => {
            console.log('Fetching szakKod for szakId:', szakId);
            try {
                const response = await getSzak(szakId);
                console.log('getSzak response:', response);
                console.log('getSzak response.data:', response.data);
                console.log('getSzak response.data.data:', response.data?.data);
                
                if (response.data && response.data.data) {
                    const szakData = response.data.data;
                    const kod = Array.isArray(szakData) ? szakData[0]?.szak_kod : szakData.szak_kod;
                    console.log('Setting szakKod to:', kod);
                    setSzakKod(kod);
                } else {
                    console.error('No data in getSzak response. Full response:', JSON.stringify(response.data));
                    setError("Unable to load program code");
                }
            } catch (err) {
                console.error("Error fetching program code:", err);
                setError("Error loading program code");
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        console.log('Rendering error state:', error);
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        console.log('Rendering loading state, szakKod is:', szakKod);
        return <div>Loading page...</div>;
    }

    console.log('Rendering LanguageProvider with szakKod:', szakKod);
    return (
        <LanguageProvider szakKod={szakKod}>
            <SzakKommContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default SzakKomm;
